// eslint-disable-next-line no-shadow
enum Header {
    PRIMARY,
    SECONDARY,
    TERTIARY
}

export default Header;
